module.exports = __webpack_public_path__ + "web.14698a6db09436ef2455.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/bgs/web.jpg
// module id = 266
// module chunks = 2